import logger from 'src/logger';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import product from 'src/common/config/product';

const withProductKey = compose(
  withRouter,
  withProps(props => {
    let productKey;
    try {
      if (props.productId) {
        productKey = product.findKeyBy.sku(props.productId);
      } else if (props.match.params.productSlug) {
        productKey = product.findKeyBy.slug(props.match.params.productSlug);
      }
    } catch (error) {
      logger.warn(error);
    }

    return { productKey };
  }),
);

export default withProductKey;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withProductKey.js